import { Customer, GtUser } from '../types';
import { loggedIn } from './metrics';

const auth = {
  signIn(user: GtUser | Customer) {
    this.storeUser(user);
    loggedIn(user.email, user.firstName, user.lastName, user.phone);
  },

  signOut() {
    window.location.href = '/account/logout';
  },

  signedIn() {
    return window.gt.user !== null;
  },

  signedOut() {
    return window.gt.user === null;
  },

  user() {
    return window.gt.user;
  },

  userId() {
    return window.gt.user ? window.gt.user.id : null;
  },

  storeUser(user: GtUser | Customer) {
    window.gt.user = {
      email: user.email!,
      emailOptIn: user.emailOptIn!, // @TODO: Fix type inconsistency in sc-46193
      firstName: String(user.firstName),
      id: user.id!,
      isCx: user.isCx,
      lastName: String(user.lastName),
      phone: user.phone!,
      primaryEventId: user.primaryEventId!,
      smsOptIn: user.smsOptIn!, // @TODO: Fix type inconsistency in sc-46193
      state: String(user.state),
    };
    this.storeJwt(user.jwt);
  },

  storeUserJson(response: GtUser | Customer) {
    window.gt.user = {
      email: response.email!,
      emailOptIn: response.email_opt_in!, // @TODO: Fix type inconsistency in sc-46193
      firstName: String(response.first_name),
      id: response.id!,
      isCx: response.is_cx,
      lastName: String(response.last_name),
      phone: response.phone!,
      primaryEventId: response.primary_event_id!,
      smsOptIn: response.sms_opt_in!, // @TODO: Fix type inconsistency in sc-46193
      state: String(response.state),
    };
    this.storeJwt(response.jwt);
  },

  storeJwt(jwt?: string) {
    if (jwt) {
      window.localStorage.setItem('jwt', jwt);
    }
  },
};

export default auth;
